import ApiCrud from "./api-crud";

class CuentaService extends ApiCrud {
  resource = "cuentas";
  primaryKey = "idcuenta";
}

export default new CuentaService();
